module.exports = __webpack_public_path__ + "img/sld_scb_31_t1_b1_green.e8c22818.svg";